import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "content", "toggleButton"]

  static values = {
    defaultTab: String
  }

  connect() {
    this.expandedTabs = new Set()
    this.selectTab(this.defaultTabValue || this.visibleTabNames()[0])
  }

  select(event) {
    event.preventDefault()
    this.selectTab(event.currentTarget.dataset.tabName)
  }

  keydown(event) {
    const tabNames = this.visibleTabNames()
    const currentIndex = tabNames.indexOf(event.currentTarget.dataset.tabName)

    if (currentIndex === -1) {
      return
    }

    let nextIndex = currentIndex

    switch (event.key) {
      case "ArrowRight":
      case "ArrowDown":
        nextIndex = (currentIndex + 1) % tabNames.length
        break
      case "ArrowLeft":
      case "ArrowUp":
        nextIndex = (currentIndex - 1 + tabNames.length) % tabNames.length
        break
      case "Home":
        nextIndex = 0
        break
      case "End":
        nextIndex = tabNames.length - 1
        break
      default:
        return
    }

    event.preventDefault()
    const nextTab = this.tabTargets.find((tab) => tab.dataset.tabName === tabNames[nextIndex])
    nextTab?.focus()
    this.selectTab(tabNames[nextIndex])
  }

  toggleExpand(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tabName

    if (!tabName) {
      return
    }

    if (this.expandedTabs.has(tabName)) {
      this.expandedTabs.delete(tabName)
    } else {
      this.expandedTabs.add(tabName)
    }

    this.updateContentHeight(tabName)
  }

  selectTab(tabName) {
    if (!tabName) {
      return
    }

    this.activeTabName = tabName

    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tabName === tabName

      tab.setAttribute("aria-selected", isActive)
      tab.setAttribute("tabindex", isActive ? "0" : "-1")
      tab.classList.toggle("btn-primary", isActive)
      tab.classList.toggle("btn-secondary", !isActive)
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tabName !== tabName
    })

    this.updateContentHeight(tabName)
  }

  visibleTabNames() {
    return this.tabTargets.map((tab) => tab.dataset.tabName).filter(Boolean)
  }

  updateContentHeight(tabName) {
    const content = this.contentTargets.find((item) => item.dataset.tabName === tabName)
    const toggleButton = this.toggleButtonTargets.find((item) => item.dataset.tabName === tabName)
    const isExpanded = this.expandedTabs.has(tabName)

    if (content) {
      content.style.maxHeight = isExpanded ? "none" : "300px"
      content.style.overflowY = isExpanded ? "visible" : "auto"
    }

    if (toggleButton) {
      toggleButton.innerHTML = isExpanded
        ? '<i class="fa-solid fa-compress"></i> Свернуть'
        : '<i class="fa-solid fa-up-right-and-down-left-from-center"></i> Развернуть'
    }
  }
}